//axios imports
import axios from "axios";

//constants imports
const { BASE_URL } = require("../constants/api.js");

//main function
async function Get(path, token, paramObj) {
  try {
    let url = BASE_URL + path;
    const header = {
      headers: token
        ? {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        : {
            "Content-Type": "application/json",
          },
    };
    if (paramObj) {
      let queryString = "";
      Object.keys(paramObj).forEach((val) => {
        if (
          paramObj[val] !== null &&
          paramObj[val] !== undefined
          // paramObj[val].length > 0
        ) {
          if (queryString.length > 0) {
            queryString += `&${val}=${paramObj[val]}`;
          } else {
            queryString += `?${val}=${paramObj[val]}`;
          }
        }
      });
      url += queryString;
      header.headers.params = paramObj;
    }
    const { data } = await axios.get(url, header);
    return data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.clear();
        // dispatch( removeUser() )
        window.location.href = process.env.PUBLIC_URL + `/login`;
      }
    }
    return error;
  }
}

export { Get };
